import { action, makeObservable, onBecomeObserved } from "mobx"

import { catchErrors, subMerchantApi } from "@src/shared/api"
import { Pagination, SubmerchantResponse } from "@src/shared/api/generated"
import { CollectionWithPagination } from "@src/shared/classes/Collection/CollectionWithPagination"
import { loading } from "@src/shared/classes/utils/loading"

export class SubMerchCollection extends loading(
  ["fetch"],
  CollectionWithPagination<SubmerchantResponse>,
) {
  constructor() {
    super()

    makeObservable(this, {
      fetch: action.bound,
    })

    const kill = onBecomeObserved(this, "isLoading", () => {
      kill()

      return this.load()
    })
  }

  async fetch() {
    try {
      const { data: { data } = {} } = await subMerchantApi.getSubmerchants()

      if (data && data.data) {
        return data as {
          data: SubmerchantResponse[]
          pagination: Pagination
        }
      }
    } catch (e: any) {
      catchErrors(e)
    }

    return null
  }
}
